import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import FieldOfCareSelect from './FieldOfCareSelect';

const FieldOfCareSelectField: React.FC<BaseFieldProps> = props => (
	<BaseField {...props}>
		<FieldOfCareSelect />
	</BaseField>
);

export default FieldOfCareSelectField;
